import { z } from 'zod';

export const UuidSchema = z.string().uuid();
export const IsoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD expected');
export const IsoTimestampSchema = z.string().datetime();

// Monetary value as decimal string with up to 2 fractional digits.
// Drizzle returns numeric(14,2) as string by default; we keep it as string end-to-end.
export const MoneySchema = z.string().regex(/^-?\d+(\.\d{1,2})?$/, 'Money expected (e.g. "1234.56")');

export const ColorSchema = z.enum(['A', 'B', 'C', 'D']);
export const ScopeSchema = z.enum(['own', 'team', 'all']);
export type Scope = z.infer<typeof ScopeSchema>;

// Single source of truth for permission keys. New keys go here and propagate
// through PermissionsMapSchema, the role editor UI, and the requirePermission
// middleware.
export const PERMISSION_KEYS = [
  'dashboard.view',
  'clients.view',
  'clients.edit',
  'invoicesIssued.view',
  'invoicesIssued.edit',
  'invoicesReceived.view',
  'invoicesReceived.edit',
  'treasury.view',
  'treasury.edit',
  'reports.view',
  'pricing.view',
  'taxes.view',
  'taxes.edit',
  'signatures.view',
  'signatures.manage',
  'admin.users.manage',
  'admin.roles.manage',
  'admin.settings.manage',
  'admin.issuer.manage',
  'admin.series.manage',
] as const;
export type PermissionKey = (typeof PERMISSION_KEYS)[number];
export const PermissionKeySchema = z.enum(PERMISSION_KEYS);

export const PermissionsMapSchema = z.record(PermissionKeySchema, z.boolean());
export type PermissionsMap = z.infer<typeof PermissionsMapSchema>;

export const ThemeSchema = z.enum(['dark-lima', 'dark-cobalto', 'light-lima', 'light-cobalto']);
export type ThemeId = z.infer<typeof ThemeSchema>;
